// Estrutura de dados com todas as páginas, botões e configurações navegáveis do sistema

export interface SearchableItem {
  id: string;
  title: string;
  description: string;
  keywords: string[];
  path: string;
  category: 'pagina' | 'configuracao' | 'acao';
  icon?: string;
}

export const searchableItems: SearchableItem[] = [
  // Páginas principais
  {
    id: 'dashboard',
    title: 'Painel de Controle',
    description: 'Visão geral e estatísticas do sistema',
    keywords: ['dashboard', 'painel', 'inicio', 'home', 'estatisticas', 'metricas', 'overview'],
    path: '/dashboard',
    category: 'pagina',
    icon: 'LayoutGrid'
  },
  {
    id: 'leads',
    title: 'Leads',
    description: 'Gerenciar leads e prospects',
    keywords: ['leads', 'prospects', 'clientes', 'contatos', 'vendas'],
    path: '/leads',
    category: 'pagina',
    icon: 'Users'
  },
  {
    id: 'new-lead',
    title: 'Novo Lead',
    description: 'Adicionar novo lead ao sistema',
    keywords: ['novo', 'lead', 'adicionar', 'criar', 'cadastrar', 'prospect'],
    path: '/leads/new',
    category: 'acao',
    icon: 'UserPlus'
  },
  {
    id: 'sales',
    title: 'Vendas',
    description: 'Gerenciar vendas e faturamento',
    keywords: ['vendas', 'faturamento', 'receita', 'pagamentos', 'transacoes'],
    path: '/sales',
    category: 'pagina',
    icon: 'ShoppingCart'
  },
  {
    id: 'new-sale',
    title: 'Nova Venda',
    description: 'Registrar nova venda',
    keywords: ['nova', 'venda', 'adicionar', 'registrar', 'criar', 'transacao'],
    path: '/sales/new',
    category: 'acao',
    icon: 'DollarSign'
  },
  {
    id: 'reports',
    title: 'Relatórios',
    description: 'Visualizar relatórios e análises',
    keywords: ['relatorios', 'analises', 'graficos', 'estatisticas', 'dashboard', 'metricas'],
    path: '/reports',
    category: 'pagina',
    icon: 'BarChart3'
  },

  // Bots e Automações
  {
    id: 'neural-core',
    title: 'Núcleo Neural',
    description: 'Configurar IA e scripts de vendas',
    keywords: ['nucleo', 'neural', 'ia', 'inteligencia', 'artificial', 'scripts', 'bot', 'automacao'],
    path: '/bots/neural-core',
    category: 'pagina',
    icon: 'Brain'
  },
  {
    id: 'bot-configs',
    title: 'Configurações do Bot',
    description: 'Configurar comportamento do bot',
    keywords: ['bot', 'configuracoes', 'settings', 'personalidade', 'comportamento', 'automacao'],
    path: '/bots/configs',
    category: 'configuracao',
    icon: 'Bot'
  },
  {
    id: 'integrations',
    title: 'Integrações',
    description: 'Conectar ferramentas externas',
    keywords: ['integracoes', 'conexoes', 'apis', 'whatsapp', 'gmail', 'email'],
    path: '/bots/integrations',
    category: 'configuracao',
    icon: 'Plug'
  },
  {
    id: 'media',
    title: 'Mídias',
    description: 'Gerenciar arquivos e mídias',
    keywords: ['midias', 'arquivos', 'imagens', 'videos', 'anexos', 'uploads'],
    path: '/bots/media',
    category: 'pagina',
    icon: 'FileText'
  },
  {
    id: 'monitoring',
    title: 'Monitoramento',
    description: 'Monitorar atividades do bot',
    keywords: ['monitoramento', 'logs', 'atividades', 'historico', 'rastreamento'],
    path: '/bots/monitoring',
    category: 'pagina',
    icon: 'Activity'
  },

  // Integrações específicas
  {
    id: 'whatsapp-integration',
    title: 'Integração WhatsApp',
    description: 'Conectar e configurar WhatsApp',
    keywords: ['whatsapp', 'wpp', 'mensagens', 'chat', 'integracao', 'qr', 'code'],
    path: '/integrations/whatsapp',
    category: 'configuracao',
    icon: 'MessageCircle'
  },
  {
    id: 'gmail-integration',
    title: 'Integração Gmail',
    description: 'Conectar e configurar Gmail',
    keywords: ['gmail', 'email', 'correio', 'mensagens', 'integracao', 'google'],
    path: '/integrations/gmail',
    category: 'configuracao',
    icon: 'Mail'
  },

  // Automações
  {
    id: 'automation-flows',
    title: 'Fluxos de Automação',
    description: 'Criar e gerenciar fluxos automatizados',
    keywords: ['automacao', 'fluxos', 'workflows', 'processos', 'sequencias'],
    path: '/automations/flows',
    category: 'pagina',
    icon: 'Workflow'
  },
  {
    id: 'automations-list',
    title: 'Lista de Automações',
    description: 'Ver todas as automações ativas',
    keywords: ['automacoes', 'lista', 'ativas', 'workflows', 'processos'],
    path: '/automations',
    category: 'pagina',
    icon: 'List'
  },
  {
    id: 'gmail-automation',
    title: 'Automação Gmail',
    description: 'Automações para Gmail',
    keywords: ['gmail', 'email', 'automacao', 'fluxos', 'mensagens'],
    path: '/automations/gmail',
    category: 'pagina',
    icon: 'Mail'
  },

  // Perfil e Configurações
  {
    id: 'profile',
    title: 'Perfil',
    description: 'Configurar perfil de usuário',
    keywords: ['perfil', 'usuario', 'conta', 'dados', 'pessoais', 'configuracoes'],
    path: '/profile',
    category: 'configuracao',
    icon: 'User'
  },
  {
    id: 'subscription',
    title: 'Assinatura',
    description: 'Gerenciar plano e assinatura',
    keywords: ['assinatura', 'plano', 'pagamento', 'upgrade', 'subscription', 'premium'],
    path: '/subscription',
    category: 'configuracao',
    icon: 'CreditCard'
  },
  {
    id: 'upgrade',
    title: 'Fazer Upgrade',
    description: 'Melhorar seu plano atual',
    keywords: ['upgrade', 'melhorar', 'plano', 'premium', 'pro', 'assinatura'],
    path: '/upgrade',
    category: 'acao',
    icon: 'TrendingUp'
  },

  // Configurações específicas do sistema
  {
    id: 'goals',
    title: 'Metas',
    description: 'Definir metas de vendas e receita',
    keywords: ['metas', 'objetivos', 'targets', 'vendas', 'receita', 'kpi'],
    path: '/profile',
    category: 'configuracao',
    icon: 'Target'
  },
  {
    id: 'preferences',
    title: 'Preferências',
    description: 'Configurar preferências do sistema',
    keywords: ['preferencias', 'configuracoes', 'settings', 'opcoes', 'personalizacao'],
    path: '/profile',
    category: 'configuracao',
    icon: 'Settings'
  },
  {
    id: 'theme',
    title: 'Tema',
    description: 'Alternar entre tema claro e escuro',
    keywords: ['tema', 'aparencia', 'dark', 'light', 'modo', 'escuro', 'claro'],
    path: '/profile',
    category: 'configuracao',
    icon: 'Palette'
  },

  // Scripts e Conteúdo
  {
    id: 'new-script',
    title: 'Novo Script',
    description: 'Criar novo script de vendas',
    keywords: ['script', 'novo', 'criar', 'adicionar', 'vendas', 'ia', 'conteudo'],
    path: '/scripts/new',
    category: 'acao',
    icon: 'FileText'
  },
  {
    id: 'scripts',
    title: 'Scripts',
    description: 'Gerenciar scripts de vendas',
    keywords: ['scripts', 'conteudo', 'vendas', 'mentalidades', 'fatos', 'persona'],
    path: '/bots/neural-core',
    category: 'pagina',
    icon: 'FileText'
  }
];
